import Vue from "vue";

// initial state
const state = {
  error: undefined
};

// getters
const getters = {
  getError(state) {
    return state.error;
  }
};

// actions
const actions = {
  clearError({commit}){
    commit('setError', undefined);
  }
};

// mutations
const mutations = {
  setError(state, payload={error: undefined}) {
    state.error = payload.error;
    return state;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
